var _desc, _defs, _rect, _g, _g2, _g3, _g4, _text, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMangatranslate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "mtTitle"
  }, "MangaTranslate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "mtTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "mtDesc"
  }, "A manga page where one speech bubble has been selected and translated to English in place.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "mtTone",
    width: 12,
    height: 12,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 1.9,
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 1.9,
    fill: "#101010"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "#fbfaf6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "28,28 388,28 352,250 28,250",
    fill: "#ffffff",
    stroke: "#101010",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mtClipA"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "28,28 388,28 352,250 28,250"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mtClipA)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "28,28 150,28 28,140",
    fill: "url(#mtTone)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#101010",
    strokeWidth: 1.8,
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 40,
    x2: 290,
    y2: 92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372,
    y1: 66,
    x2: 300,
    y2: 112
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 242,
    x2: 98,
    y2: 196
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 246,
    x2: 124,
    y2: 206
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204,
    cy: 132,
    rx: 92,
    ry: 62,
    fill: "#ffffff",
    stroke: "#101010",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 186 L150 226 L204 192 Z",
    fill: "#ffffff",
    stroke: "#101010",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 182,
    width: 60,
    height: 10,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 204,
    y: 122,
    textAnchor: "middle",
    fontFamily: "'Yu Gothic UI', 'Yu Gothic', 'Hiragino Sans', 'Noto Sans CJK JP', sans-serif",
    fontSize: 27,
    fontWeight: 700,
    fill: "#101010"
  }, "\u3053\u3093\u306B"), /*#__PURE__*/React.createElement("text", {
    x: 204,
    y: 154,
    textAnchor: "middle",
    fontFamily: "'Yu Gothic UI', 'Yu Gothic', 'Hiragino Sans', 'Noto Sans CJK JP', sans-serif",
    fontSize: 27,
    fontWeight: 700,
    fill: "#101010"
  }, "\u3061\u306F\uFF01")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "412,28 772,28 772,250 376,250",
    fill: "#ffffff",
    stroke: "#101010",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mtClipB"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "412,28 772,28 772,250 376,250"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mtClipB)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "772,28 650,28 772,140",
    fill: "url(#mtTone)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#101010",
    strokeWidth: 1.8,
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 44,
    x2: 486,
    y2: 94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408,
    y1: 70,
    x2: 478,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 240,
    x2: 700,
    y2: 198
  }), /*#__PURE__*/React.createElement("line", {
    x1: 726,
    y1: 246,
    x2: 672,
    y2: 208
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 590,
    cy: 132,
    rx: 92,
    ry: 62,
    fill: "#ffffff",
    stroke: "#101010",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 186 L536 226 L590 192 Z",
    fill: "#ffffff",
    stroke: "#101010",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 182,
    width: 60,
    height: 10,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 142,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', system-ui, sans-serif",
    fontSize: 31,
    fontWeight: 800,
    fill: "#101010",
    letterSpacing: 0.5
  }, "HELLO!"), /*#__PURE__*/React.createElement("g", {
    stroke: "#0891b2",
    strokeWidth: 3.5,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482 76 L482 60 L502 60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678 60 L698 60 L698 76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698 188 L698 204 L678 204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 204 L482 204 L482 188"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 482,
    y: 60,
    width: 216,
    height: 144,
    fill: "#0891b2",
    opacity: 0.06
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M356 139 L396 139",
    stroke: "#0891b2",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 126 L410 139 L390 152 Z",
    fill: "#0891b2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 272,
    width: 744,
    height: 92,
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#fbfaf6",
    strokeWidth: 2,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 284,
    x2: 120,
    y2: 284
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 352,
    x2: 96,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 284,
    x2: 760,
    y2: 284
  }), /*#__PURE__*/React.createElement("line", {
    x1: 704,
    y1: 352,
    x2: 760,
    y2: 352
  })), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 330,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', system-ui, sans-serif",
    fontSize: 34,
    fontWeight: 800,
    fill: "#fbfaf6",
    letterSpacing: 6
  }, "MANGATRANSLATE"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 416,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', system-ui, sans-serif",
    fontSize: 16,
    fill: "#9a958c"
  }, "\u2014 05 \u2014")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "772,450 772,398 720,450",
    fill: "url(#mtTone)",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMangatranslate);
export default __webpack_public_path__ + "static/media/mangatranslate.2500e95ed88e1653fa87db231c7bbd72.svg";
export { ForwardRef as ReactComponent };